/**
 * Re-export of the defensive prop coercion helpers that live in the
 * runtime. The canonical implementation moved into
 * {@code @akademi/site-builder-runtime/portal/coerce} so every theme
 * package and host can import from one source instead of duplicating
 * the helpers per workspace.
 *
 * <p>This module stays as a relative-import seam for blocks inside
 * this package so the existing
 * {@code import { tx } from '../_shared/coerce'} call sites don't
 * have to change.
 */

export { tx, asList, asNumber, asBool, asObject, pickEnum } from '@akademi/site-builder-runtime';
